import * as React from 'react';

import { TextExternalLink } from '@/components/elements/Text/TextLink';
import { TORETA_HELP_URL } from '@/config/constants/guide';

import { NotesList, NotesTitle } from './style';

const GuideToretaNotesList: React.FC = () => {
  return (
    <>
      <NotesTitle>【注意事項】</NotesTitle>
      <NotesList>
        <li>
          <span>
            toreta+
            には有効期限があります。有効期限内にご利用にならなかった場合は失効となります。
            <br />
            チャージ方法によって設定される期間が異なりますので、マイページの「
            <TextExternalLink
              href={import.meta.env.VITE_DMM_TORETA_HISTORY_URL}
            >
              toreta+利用情報
            </TextExternalLink>
            」よりご確認ください。
          </span>
        </li>
        <li>
          toreta+ は返金や換金することはできません。あらかじめご了承ください。
        </li>
        <li>
          toreta+
          はコンビニで販売している「DMMプリペイドカード」「DMMポイントコード」とは異なります。
        </li>
        <li>
          toreta+
          は「DMMポイント」「DMMプリペイドカード」からのチャージは行えません。
        </li>
        <li>
          <span>
            その他ご不明な点につきましては、
            <TextExternalLink href={TORETA_HELP_URL}>
              toreta+ のよくある質問
            </TextExternalLink>
            をご確認ください。
          </span>
        </li>
      </NotesList>
    </>
  );
};

export default GuideToretaNotesList;
